<template>
  <div class="page">
    <div class="warning">营养康复内容仅供参考，涉及多种疾病患者营养应咨询医生或者营养师。</div>
    <div class="title">{{ data.recoveryTitle }}</div>
    <div class="time">{{data.createTime}}</div>
    <div class="content"
         v-html="data.recoveryContent"></div>
    <div class="block"
         v-if="isShare == 1"></div>
    <div v-if="isShare == 1"
         class="download">
      <img class="logo"
           src="@/assets/logo.png">
      <div class="tip">不舒服，点点我！<br />哪里不舒服，就点哪里！</div>
      <a class="btn"
         href="/download">立即下载</a>
    </div>
  </div>
</template>

<script>
import { nutritionDetail } from '@/api/nutrition'

export default {
  name: 'detail',
  data() {
    return {
      isShare: 0,
      id: null,
      data: {}
    }
  },
  created() {
    document.title = '健康营养'
    this.id = this.$route.query.id
    this.isShare = this.$route.query.isShare || 0
    this.init()
  },
  methods: {
    init() {
      nutritionDetail({ id: this.id }).then(res => {
        res.result.recoveryContent = this.formatRichText(res.result.recoveryContent)
        this.data = res.result
        document.title = this.data.recoveryTitle || '健康营养'
      })
    },
    formatRichText(detailText) {
      detailText = detailText.replace(/<img[^>]*>/gi, function (match) {
        return match.replace(/(style="(.*?)")|(width="(.*?)")|(height="(.*?)")/ig,
          'style="max-width:100%;height:auto;"')
      });
      return detailText;
    },
  }
}
</script>

<style scoped>
.warning {
  padding: 10px 15px;
  font-size: 12px;
  color: #e5ae54;
  background: #faeeda;
}
.title {
  padding: 10px 20px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #333;
}
.time {
  text-align: center;
  font-size: 14px;
  color: #999;
}
.content {
  padding: 0 20px;
  font-size: 18px;
}
.block {
  height: 75px;
}
.download {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 15px;
  background-color: white;
  border-top: 1px solid #f2f2f2;
}
.download .logo {
  width: 50px;
  height: 50px;
}
.download .tip {
  flex: 1;
  margin: 0 10px;
  font-size: 13px;
  color: #999999;
}
.download .btn {
  padding: 5px 15px;
  color: white;
  text-decoration: none;
  background: #0063aa;
  border-radius: 25px;
}
</style>